module.exports = require('react/lib/cloneWithProps');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-clone-with-props/index.js
 ** module id = 160
 ** module chunks = 0
 **/